import { RQ } from 'utils';
import * as wx from 'utils/wx';
import { addClickAnalytics } from 'utils/analytics';

export default {
  getOrderPayPrice: async function () {
    const res = await RQ.mall.get('/api/h5/order/getOrderPayPrice', { orderId: this.params.orderId });
    if (res && res.code == 0) {
      const data = res.data;
      const isSingle = data.usableMoney != undefined && data.usableMoney != 0 && data.combinationPay == 0;
      const isCombination = data.usableMoney != undefined && data.usableMoney !== 0;
      const isRMSingle = data.reserveMoney != 0 && data.reserveMoneyPay == 1 && data.combinationReserveMoneyPay == 0; // 支持预存款单独支付
      const isRMCombination = data.reserveMoney != 0 && data.reserveMoneyPay == 1; // 预存款金额不为空
      this.data = {
        payRes: res,
        payInfo: data,
        balancePayway: isCombination,
        isCombination: isCombination,
        isSingle: isSingle,
        balanceRMPayway: !isCombination && isRMCombination, //预存款支付
        isRMSingle: isRMSingle,
        isRMCombination: isRMCombination,
        payway: isSingle ? undefined : isRMSingle ? undefined : 'wechat',
        ...res.data
      };
    } else {
      this.tips(res.msg);
    }
  },
  selectBalancePayway: function () {
    if (this.data.usableMoney !== 0) {
      this.data.balanceRMPayway = false;
      this.data.balancePayway = !this.data.balancePayway;
      this.data.payway = this.data.isSingle ? undefined : this.data.payway;
    }
  },
  selectBalanceRMPayway: function () {
    if (this.data.reserveMoneyPay == 1 && this.data.reserveMoney != 0) {
      this.data.balancePayway = false;
      this.data.balanceRMPayway = !this.data.balanceRMPayway;
      this.data.payway = this.data.isRMSingle ? undefined : this.data.payway;
    }
  },
  selectPayWay: function (payway) {
    const { isSingle, isCombination, isRMSingle, isRMCombination, balancePayway, balanceRMPayway } = this.data;
    console.log('selectPayWay', payway, isSingle, isCombination);
    if (balancePayway) {
      if (isSingle) {
        this.data.balancePayway = false;
        this.data.payway = this.data.payway == payway ? (isCombination ? payway : undefined) : payway;
      } else {
        this.data.payway = this.data.payway == payway ? (isCombination ? payway : undefined) : payway;
      }
    } else if (balanceRMPayway) {
      if (isRMSingle) {
        this.data.balanceRMPayway = false;
        this.data.payway = this.data.payway == payway ? (isRMCombination ? payway : undefined) : payway;
      } else {
        this.data.payway = this.data.payway == payway ? (isRMCombination ? payway : undefined) : payway;
      }
    } else {
      this.data.payway = this.data.payway == payway ? undefined : payway;
    }
  },
  pay: async function () {
    addClickAnalytics({ LogTitle: '确认支付' });
    if (this.data.balancePayway == false && this.data.balanceRMPayway == false && this.data.payway == undefined) {
      this.tips('请选择支付方式');
      return;
    }
    const res = await RQ.mall.post('/api/h5/order/saveOrderPayInfo', {
      orderId: this.params.orderId,
      payWay: this.data.payway,
      usableAccountPay: this.data.balancePayway ? 1 : 0,
      usableReserveMoneyPay: this.data.balanceRMPayway ? 1 : 0,
      clientType: 2, // 1：app，2：h5，3：小程序
      isPlatform: G.is_platform !== undefined ? G.is_platform : 0
    }, { jsonBody: true });

    if (res && res.code == 0) {
      wx.pay(this.$route, res.data, () => {
        // 支付成功
        this.$router.replace({
          path: `/${G.enterprise}/cart/paySuccess?orderId=${this.params.orderId}&orderCode=${this.data.orderCode}&orderPrice=${this.data.orderPrice}`
        });

      }, () => {
        // 支付失败
        RQ.mall.put('/api/h5/order/updateOrderCancelPay', { orderId: this.params.orderId });
      }, () => {
        // 支付取消
        RQ.mall.put('/api/h5/order/updateOrderCancelPay', { orderId: this.params.orderId });
      });
    } else if (res && res.code == 6) {
      this.$router.replace({
        path: `/${G.enterprise}/cart/paySuccess?orderId=${this.params.orderId}&orderCode=${this.data.orderCode}&orderPrice=${this.data.orderPrice}`
      });
    } else {
      this.tips(res.msg || '获取支付参数失败');
    }
  }
};



// WEBPACK FOOTER //
// ./src/module/cart/pay/action.js